import {Box, Clickable, Heading, HStack, Icon, Text, VStack} from 'platform/foundation';

import {useState} from 'react';

import {RecordAuditResponseBody, RecordAuditTask} from '@dms/api/core';
import i18n from '@dms/i18n';
import {settingsRoutes} from '@dms/routes';

import {composePath, useNavigate} from 'shared/web';

import {RecordAuditScorableResult} from '../../../score/computeRecordAuditScore';
import {RecordAuditForm} from './RecordAuditForm/RecordAuditForm';
import {RecordAuditScoreBar, RecordAuditScoreFilter} from './RecordAuditScoreBar';

interface RecordAuditSnapshotPanelProps {
  audit: RecordAuditResponseBody;
  tasks: ReadonlyArray<RecordAuditTask>;
  liveResults: ReadonlyArray<RecordAuditScorableResult>;
  isEditable: boolean;
}

export function RecordAuditSnapshotPanel(props: RecordAuditSnapshotPanelProps) {
  const navigate = useNavigate();
  const [activeFilter, setActiveFilter] = useState<RecordAuditScoreFilter>('all');

  const openTemplate = () => {
    navigate(
      composePath(settingsRoutes.recordAuditDefinitionDetail, {
        params: {id: props.audit.definitionSnapshot.recordAuditDefinitionId},
      })
    );
  };

  return (
    <Box
      backgroundColor="palettes.white.10.100"
      border="1px solid"
      borderColor="palettes.neutral.40.100"
      borderRadius="medium"
    >
      <VStack spacing={0}>
        <Box padding={4}>
          <HStack justify="space-between" align="flex-start">
            <VStack spacing={0}>
              <Heading size={4}>{i18n.t('page.checklistAudits.detail.checklist')}</Heading>
              <Text size="xSmall" color="secondary">
                {props.audit.definitionSnapshot.name}
              </Text>
            </VStack>
            <Clickable
              onClick={openTemplate}
              data-testid="recordAuditDetail-checklistPanel-openTemplate"
            >
              <HStack spacing={1} align="center">
                <Icon value="action/open_in_new" size={4} color="palettes.neutral.70.100" />
                <Text size="xSmall" color="tertiary" noWrap>
                  {i18n.t('page.checklistAudits.detail.openTemplate')}
                </Text>
              </HStack>
            </Clickable>
          </HStack>
        </Box>

        <Box
          position="sticky"
          top={0}
          zIndex="CONTENT"
          backgroundColor="palettes.neutral.20.100"
          borderTop="1px solid"
          borderBottom="1px solid"
          borderColor="palettes.neutral.40.100"
          paddingHorizontal={4}
          paddingVertical={4}
        >
          <RecordAuditScoreBar
            audit={props.audit}
            liveResults={props.liveResults}
            activeFilter={activeFilter}
            onFilterChange={setActiveFilter}
          />
        </Box>

        <Box padding={4}>
          <RecordAuditForm
            audit={props.audit}
            tasks={props.tasks}
            isDisabled={!props.isEditable}
            activeFilter={activeFilter}
          />
        </Box>
      </VStack>
    </Box>
  );
}
